import React from 'react';

import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ActionItemKeys, NotificationResponse } from '@uplift/api';
import { useActionItem } from '@uplift/hooks';
import { Modal, ModalContent } from '@uplift/ui-v2';

const useStyles = makeStyles()(theme => ({
  title: {
    paddingTop: '26px',
  },
  content: {
    paddingTop: 0,
    paddingBottom: theme.spacing(5),
  },
  iframe: {
    width: '100%',
    aspectRatio: '16/9',
  }
}));

export type WelcomeToNewCalendarNotificationProps = {
  showTutorial: boolean;
  setShowTutorial: (v: boolean) => void;
};

export const WelcomeToNewCalendarNotification: React.VFC<WelcomeToNewCalendarNotificationProps> = ({ showTutorial, setShowTutorial }) => {
  const { classes } = useStyles();
  const actionItem = useActionItem(ActionItemKeys.NEW_CALENDAR_WELCOME);

  return (
    <Modal
      loading={actionItem.isDismissing}
      classes={{ title: classes.title }}
      title="Welcome to your new calendar!"
      open={actionItem.showWelcomeToCalendarModal || showTutorial}
      onClose={() => {
        if (actionItem.showWelcomeToCalendarModal) {
          actionItem.dismiss(NotificationResponse.dismiss);
        }
        setShowTutorial(false);
      }}
      maxWidth="md"
    >
      <ModalContent className={classes.content}>
        <Typography color="textSecondary">With Matching Availability, you have complete control over your schedule directly in your BetterHelp account. Make instant changes to your weekly available hours or just a single day’s schedule, whenever you want.</Typography>

        <Box pt={5}>
          <iframe
            className={classes.iframe}
            width="640"
            height="360"
            src={actionItem.videoUrl}
            title="YouTube video player"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Box>
      </ModalContent>
    </Modal>
  );
};
